import React, { useEffect, useState } from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import { portfolio as t } from "../Themes"

const Bar = styled(motion.header)`
position: fixed;
top: 0;
left: 0;
right: 0;
z-index: 50;
display: flex;
align-items: center;
justify-content: space-between;
padding: 1.1rem clamp(1.25rem, 5vw, 4rem);
transition: background-color 0.3s ease, border-color 0.3s ease, backdrop-filter 0.3s ease;

background-color: ${(p) => (p.scrolled ? "rgba(13, 15, 18, 0.72)" : "transparent")};
backdrop-filter: ${(p) => (p.scrolled ? "blur(14px)" : "none")};
border-bottom: 1px solid ${(p) => (p.scrolled ? t.border : "transparent")};
`

const Logo = styled.a`
font-family: 'Pacifico', cursive;
font-size: 1.6rem;
color: ${t.text};
letter-spacing: 0.5px;
span{ color: ${t.accent}; }
`

const Nav = styled.nav`
display: flex;
align-items: center;
gap: 2.2rem;

@media (max-width: 52em){
    display: none;
}
`

const Link = styled.a`
font-family: ${t.mono};
font-size: 0.82rem;
color: ${t.muted};
letter-spacing: 0.02em;
transition: color 0.2s ease;
position: relative;

&:hover{ color: ${t.text}; }

i{ color: ${t.accent}; font-style: normal; margin-right: 0.4rem; }
`

const Cta = styled.a`
font-family: ${t.mono};
font-size: 0.82rem;
color: ${t.accent};
border: 1px solid rgba(${t.accentRgba}, 0.45);
padding: 0.5rem 1.1rem;
border-radius: 999px;
transition: all 0.2s ease;

&:hover{
    background-color: ${t.accentDim};
    border-color: ${t.accent};
    transform: translateY(-1px);
}
`

const links = [
    { id: "about", label: "About" },
    { id: "experience", label: "Experience" },
    { id: "skills", label: "Skills" },
    { id: "work", label: "Work" },
]

const Navbar = () => {
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24)
        window.addEventListener("scroll", onScroll)
        onScroll()
        return () => window.removeEventListener("scroll", onScroll)
    }, [])

    return (
        <Bar
            scrolled={scrolled ? 1 : 0}
            initial={{ y: -80, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
        >
            <Logo href="#top" aria-label="Bereket Zelalem — home">
                B<span>Z</span>
            </Logo>
            <Nav>
                {links.map((l, i) => (
                    <Link key={l.id} href={`#${l.id}`}>
                        <i>0{i + 1}.</i>
                        {l.label}
                    </Link>
                ))}
                <Cta href="#contact">Say hi</Cta>
            </Nav>
        </Bar>
    )
}

export default Navbar
